"use client";

import { safeWindow } from "@/utils/safe-window";
import { useCallback } from "react";

export const LOCAL_STORAGE_KEY = {
  // デジタル認証アプリのOIDCでの state を保存するためのキー
  digitalIdentificationAppState: "digitalIdentificationAppState",
  // デジタル認証アプリのOIDCでの nonce を保存するためのキー
  digitalIdentificationAppNonce: "digitalIdentificationAppNonce",
  // デジタル認証アプリのOIDCでの codeVerifier を保存するためのキー
  digitalIdentificationAppCodeVerifier: "digitalIdentificationAppCodeVerifier",
  cookieConsent: "cookie-consent",
} as const;

type LocalStorageKey = keyof typeof LOCAL_STORAGE_KEY;

export function useLocalStorage() {
  const setItem = useCallback((key: LocalStorageKey, value: string) => {
    safeWindow?.localStorage.setItem(key, value);
  }, []);

  const getItem = useCallback((key: LocalStorageKey) => {
    return safeWindow?.localStorage.getItem(key) ?? undefined;
  }, []);

  const removeItem = useCallback((key: LocalStorageKey) => {
    safeWindow?.localStorage.removeItem(key);
  }, []);

  return {
    setItem,
    getItem,
    removeItem,
  };
}
